<template>
  <div class="page" v-loading="loading">
    <div class="flex space_between">
      <div class="flex">
        <el-input
          v-model="search.search"
          style="width: 210px; margin-right: 10px"
          placeholder="请输入班级名称"
        />
        <el-button color="#FF7739" @click="onSearch">搜索</el-button>
      </div>

      <el-button color="#FF7739" @click="create">添加班级</el-button>
    </div>
    <br />
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        'text-align': 'center',
        background: '#FFF7EB',
        color: '#FF7739',
      }"
    >
      <el-table-column type="index" label="NO" align="center" />
      <el-table-column prop="sys_class_name" label="班级名称" align="center" />
      <el-table-column
        prop="school_usercount_count"
        label="人数"
        align="center"
      >
        <template #default="scope">
          <el-link type="success" @click="toPerson(scope.row)">
            {{ scope.row.school_usercount_count }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="banzhang.mem_name"
        label="负责老师"
        align="center"
      />
      <el-table-column prop="sys_class_note" label="备注" align="center" />
      <el-table-column prop="" label="编辑" align="center">
        <template #default="scope">
          <el-button
            color="#FF7739"
            icon="Edit"
            circle
            @click="edit(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>

    <!-- <Pagination @pageChange="pageChangeFn" :total="total"></Pagination> -->

    <el-dialog v-model="dialogShow" title="" width="30%">
      <el-form ref="formRef" :model="form" label-width="130px">
        <el-form-item
          label="班级名称"
          prop="sys_class_name"
          :rules="[
            {
              required: true,
              message: '请输入班级名称',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.sys_class_name"
            placeholder="请输入班级名称"
          />
        </el-form-item>
        <el-form-item label="备注" prop="sys_class_note">
          <el-input v-model="form.sys_class_note" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="负责老师" prop="mem_id">
          <el-input v-model="form.mem_id" placeholder="请输入用户ID" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            color="#FF7739"
            @click="onSubmit(formRef)"
            :loading="btn_loading"
          >
            提交
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { reactive, ref, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Pagination from '../../components/Pagination'
import { getList, handleAdd } from '../../request/classList'

export default {
  components: { Pagination },
  setup() {
    const formRef = ref()
    const router = useRouter()
    const state = reactive({
      loading: false,
      dialogShow: false,
      total: 0,
      search: { page: 1 },
      form: {},
      tableData: [],
    })
    onMounted(() => {
      init()
    })

    const init = async () => {
      state.loading = true
      const { data, code, msg, total } = await getList(state.search)
      state.loading = false
      if (code == 200) {
        state.tableData = data
        // state.total = total
      } else {
        ElMessage.error(msg)
        return
      }
    }

    const onSearch = () => {
      state.search.page = 1
      init()
    }

    const pageChangeFn = value => {
      state.search.page = value
      init()
    }
    const create = () => {
      state.dialogShow = true
      state.form = {}
    }
    const onSubmit = async (a, b) => {
      if (!formRef) return
      formRef.value.validate(valid => {
        if (valid) {
          state.btn_loading = true
          confirm()
        }
      })
    }
    const confirm = async () => {
      const { data, code, msg } = await handleAdd(state.form)
      state.btn_loading = false
      if (code == 200) {
        ElMessage.success(msg)
        state.dialogShow = false
        init()
      } else {
        ElMessage.error(msg)
        return
      }
    }
    const edit = row => {
      state.dialogShow = true
      state.form = Object.assign({}, row)
    }
    const toPerson = row => {
      router.push({
        name: 'PersonList',
        params: { id: row.sys_class_id, name: row.sys_class_name },
      })
    }

    return {
      ...toRefs(state),
      formRef,
      init,
      onSearch,
      onSubmit,
      create,
      edit,
      pageChangeFn,
      toPerson,
    }
  },
}
</script>

<style lang="less" scoped>
.el-button {
  color: #fff;
}
</style>
